import { usePermissionStore } from "features/common/permissions/usePermissionStore"
import { LevelAbility, ClientAbility } from "suus-api"
import { Ref, ref, watchEffect } from "vue"

export function usePermissionCheck() {
  const { levelPermissions, clientPermissions, currentClientId } =
    usePermissionStore()

  const hasLevelPermission = (levelId: number, ability: LevelAbility) => {
    const hasLevelPermissionRef = ref(false)

    watchEffect(() => {
      hasLevelPermissionRef.value = levelPermissions.value.includes(
        `${ability}@${levelId}`
      )
    })

    return hasLevelPermissionRef
  }

  const hasClientPermission = (
    permissionName: ClientAbility,
    relevantClientId?: number
  ): Ref<boolean> => {
    const hasClientPermissionRef = ref(false)

    watchEffect(() => {
      if (relevantClientId && relevantClientId != currentClientId.value) {
        hasClientPermissionRef.value = false
        return
      }
      hasClientPermissionRef.value =
        clientPermissions.value.includes(permissionName)
    })

    return hasClientPermissionRef
  }

  const hasLevelPermissionOrClientFallback = (
    levelId?: number,
    levelPermissionName?: LevelAbility,
    clientPermissionName?: ClientAbility
  ): Ref<boolean> => {
    if (levelId && levelPermissionName) {
      return hasLevelPermission(levelId, levelPermissionName)
    } else {
      return hasClientPermission(clientPermissionName)
    }
  }

  return {
    hasLevelPermission,
    hasClientPermission,
    hasLevelPermissionOrClientFallback,
  }
}
